/**
 * Default score threshold for Google reCAPTCHA V3
 * Values below this will trigger V2 fallback(if enabled)
 */
export const DEFAULT_V3_SCORE = Number(process.env.MIX_CAPTCHA_V3_SCORE) || 0.5;

/**
 * Delay in ms before rendering the captcha widget
 */
export const WIDGET_RENDER_DELAY_MS = 100;

/**
 * Polling interval in ms for checking if the captcha API is ready
 */
export const API_READY_CHECK_INTERVAL_MS = 100;

/**
 * Timeout in ms for script loading before error
 */
export const SCRIPT_LOAD_TIMEOUT_MS = 10000;

/**
 * Delay in ms before resetting the captcha flag
 */
export const CAPTCHA_RESET_DELAY_MS = 300;

/**
 * Token refresh timeout in ms
 */
export const TOKEN_REFRESH_TIMEOUT_MS = 5000;

/**
 * Field names for different captcha providers
 */
export const CAPTCHA_FIELDS = {
    TURNSTILE: 'cf-turnstile-response',
    GOOGLE_V2: 'g-recaptcha-response',
    GOOGLE_V3: 'g-recaptcha-response',
} as const;
